import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "container",
    "template",
    "varietyGroup",
    "varietySelect",
    "percentageInput",
    "totalPercentage",
    "destroyField",
  ];
  static values = {
    maxVarieties: Number,
  };

  connect() {
    this.validatePercentages();
  }

  addVariety(event) {
    event.preventDefault();
    // if (this.varietyGroupTargets.length >= this.maxVarietiesValue) {
    //   alert(`Maximum of ${this.maxVarietiesValue} varieties allowed`);
    //   return;
    // }
    // Use a unique index for each new variety
    const uniqueIndex = Date.now() + Math.floor(Math.random() * 10000);
    let templateHtml = this.templateTarget.innerHTML;
    templateHtml = templateHtml.replace(/NEW_INDEX/g, uniqueIndex);
    // Create a DOM node from the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = templateHtml;
    const newNode = tempDiv.firstElementChild;
    this.containerTarget.appendChild(newNode);
    this.validatePercentages();
  }

  removeVariety(event) {
    event.preventDefault();
    const group = event.target.closest(
      '[data-organization-wine-varieties-target="varietyGroup"]',
    );
    const destroyField = group.querySelector(
      '[data-organization-wine-varieties-target="destroyField"]',
    );

    if (group.dataset.persisted === "true") {
      // If the variety is persisted, mark it for destruction
      destroyField.value = "1";
      group.style.display = "none";
    } else {
      // If it's a new variety, just remove it from the DOM
      group.remove();
    }

    this.validatePercentages();
  }

  validatePercentages() {
    const percentages = this.percentageInputTargets
      .filter((input) => {
        const group = input.closest(
          '[data-organization-wine-varieties-target="varietyGroup"]',
        );
        const destroyField = group.querySelector(
          '[data-organization-wine-varieties-target="destroyField"]',
        );
        return destroyField.value !== "1"; // Only include non-destroyed varieties
      })
      .map((input) => parseFloat(input.value) || 0);

    const total = percentages.reduce((sum, val) => sum + val, 0);
    this.totalPercentageTarget.textContent = `${total.toFixed(1)}%`;

    // Add visual feedback for total percentage
    if (total === 100) {
      this.totalPercentageTarget.classList.remove("text-red-600");
      this.totalPercentageTarget.classList.add("text-green-600");
    } else {
      this.totalPercentageTarget.classList.remove("text-green-600");
      this.totalPercentageTarget.classList.add("text-red-600");
    }
  }
}
